/**
 * Created by dok on 01/02/2017.
 */
angular.module('tf.controllers')

    .controller('AddMembersController', ['$scope', 'FarmService', 'NotificationService', '$timeout', 'farm',
        function ($scope, FarmService, NotificationService, $timeout, farm) {

            $scope.settingsChanged = false;
            $scope.isWorking = false;
            $scope.farm = farm;

            $scope.newUsers = {
                emails  : [],
                role    : 'editor'
            };
            $scope.groups = {
                groups : []
            };

            setTimeout(function(){$('.modal input').first().focus();},1);

            $scope.addMembers = function(){
                $scope.isWorking = true;
                FarmService.addMembers($scope.newUsers.emails, $scope.newUsers.role, $scope.groups.groups).then(function () {
                    $scope.$close(true);
                    $scope.isWorking = false;
                }, function(){
                    $('.settings-bottom-menu .settings-button i.fa-spin').removeClass('fa-spin');
                    $scope.isWorking = false;
                });
            };


            var unwatch = $scope.$watch('newUsers.emails', function(newVal, oldVal){
                if(newVal && oldVal && !_.isEqual(newVal, oldVal)){
                    unwatch();
                    $scope.settingsChanged = true;
                }
            }, true);

            $scope.cancel = function(){
                if($scope.settingsChanged) {
                    event.preventDefault();
                    NotificationService.popup('confirm-settings-exit', {
                        onLeave: function(){
                            $timeout(function(){$scope.$close();},200);
                        }
                    },{backdrop : false});
                } else {
                    $scope.$close();
                }
            };
        }
    ]
);